import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import eventBus from '../../utils/eventBus.js';
import styles from './button.css.js';
import ButtonLinkBase from '../ButtonLinkBase/ButtonLinkBase.js';
var Button = React.forwardRef(function (_ref, ref) {
  var _cn;

  var _ref$elementType = _ref.elementType,
      elementType = _ref$elementType === void 0 ? 'button' : _ref$elementType,
      children = _ref.children,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      _onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["elementType", "children", "secondary", "tertiary", "onClick"]);

  var primary = !secondary && !tertiary;
  return React.createElement(ButtonLinkBase, _extends({
    className: cn(styles['Button'], (_cn = {}, _defineProperty(_cn, styles['Button--primary'], primary), _defineProperty(_cn, styles['Button--secondary'], secondary), _defineProperty(_cn, styles['Button--tertiary'], tertiary), _cn)),
    elementType: elementType,
    primaryButton: primary,
    ref: ref,
    onClick: function onClick(e) {
      var text = e.target.textContent || '';
      eventBus.dispatch({
        type: 'onClick',
        component: 'Button',
        text: text.trim()
      });
      _onClick && _onClick(e);
    }
  }, rest), children);
});
Button.displayName = 'Button';
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  elementType: PropTypes.oneOf(['button', 'a']),
  component: PropTypes.func,
  children: PropTypes.node,

  /**
   * proxied to eventBus
   */
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,

  /**
   * To be used in conjunction with `elementType = 'a'`
   */
  external: PropTypes.bool,

  /**
   * To be used in conjunction with `elementType = 'a'`
   */
  textMap: PropTypes.shape({
    newWindow: PropTypes.string
  }),
  iconSlotLeft: PropTypes.node,
  iconSlotRight: PropTypes.node
} : {};
Button.defaultProps = {
  elementType: 'button',
  secondary: false,
  tertiary: false,
  textMap: {
    newWindow: 'Opens in a new window'
  }
};
export default Button;